import React from 'react';
import BlobPathRenderer from './BlobPathRenderer';

interface BlobPathCellRendererProps {
  value: string;
  onPopupCenter: (url: string, title: string, w: number, h: number) => void;
}

const BlobPathCellRenderer: React.FC<BlobPathCellRendererProps> = ({ 
  value, 
  onPopupCenter 
}) => {
  return <BlobPathRenderer value={value} onPopupCenter={onPopupCenter} />;
};

export default BlobPathCellRenderer;
